import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [admin, setAdmin] = useState(null); // null = loading, false = guest, object = authed
  const [needsSetup, setNeedsSetup] = useState(false);

  const refresh = useCallback(async () => {
    if (!localStorage.getItem("ukf_token")) {
      setAdmin(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setAdmin(data);
    } catch {
      localStorage.removeItem("ukf_token");
      setAdmin(false);
    }
  }, []);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/auth/setup-status");
        setNeedsSetup(!data.is_setup);
      } catch {
        setNeedsSetup(false);
      }
      await refresh();
    })();
  }, [refresh]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("ukf_token", data.token);
    setAdmin({ email: data.email, name: data.name, role: data.role });
  };

  const setup = async (password) => {
    const { data } = await api.post("/auth/setup", { password });
    localStorage.setItem("ukf_token", data.token);
    setAdmin({ email: data.email, name: data.name, role: data.role });
    setNeedsSetup(false);
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch { /* ignore */ }
    localStorage.removeItem("ukf_token");
    setAdmin(false);
  };

  return (
    <AuthContext.Provider value={{ admin, needsSetup, login, setup, logout, refresh, setNeedsSetup }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
